<template>
  <ul flex flex-wrap gap-2>
    <li
      class="after:(content-[',_'] nth-last-2:content-[',_and_'] last:content-none) font-bold"
      v-for="land in props.nativeLands"
      :key="land.url"
    >
      <a
        class="underline underline-dashed underline-2 underline-offset-2 underline-blue hover:text-neutral-400"
        :href="land.url"
        target="_blank"
      >
        {{ land.name }}
      </a>
    </li>
  </ul>
</template>
<script setup>
const props = defineProps({
  nativeLands: {
    type: Array,
    default: [],
  },
});
</script>
